import { render, staticRenderFns } from "./ItemTabFilter.vue?vue&type=template&id=029cd2b0&scoped=true&"
import script from "./ItemTabFilter.vue?vue&type=script&lang=js&"
export * from "./ItemTabFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029cd2b0",
  null
  
)

export default component.exports